import Map from './Map';
import {
  PanelRow,
  RangeControl,
  ToggleControl,
  __experimentalNumberControl,
  PanelBody,
  TextControl,
} from '@wordpress/components';
import { InspectorControls } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import './style.scss';

const Leaflet = {
  title: __('Leaflet'),
  description: __('Leaflet Map block for the ABS theme'),
  icon: 'location',
  attributes: {
    blockId: {
      type: 'string',
    },
    latitude: {
      type: 'number',
      default: 47.3523658
    },
    longitude: {
      type: 'number',
      default: 7.9022861
    },
    zoom: {
      type: 'number',
      default: 16
    },
    marker: {
      type: 'boolean',
      default: false
    },
    markerText: {
      type: 'string',
      default: ''
    }
  },
  edit: (props) => {
    const { attributes, setAttributes, clientId } = props;
    const { latitude, longitude, zoom, marker, markerText } = attributes;
    setAttributes({ blockId: clientId });

    return (
      <Fragment>
        <Map clientId={ clientId } latitude={ latitude } longitude={ longitude } zoom={ zoom } marker={ marker } markerText={ markerText }/>
        <InspectorControls>
          <PanelBody
            title={ __('Point Of Interest') }
            initialOpen={true}
          >
            <PanelRow>
              <__experimentalNumberControl
                label={ __('Latitude') }
                value={ latitude }
                required={ true }
                isDragEnabled={ false }
                onChange={ ( value ) => {
                  setAttributes( { latitude: parseFloat(value) } );
                } }
              />
            </PanelRow>
            <PanelRow>
              <__experimentalNumberControl
                label={ __('Longitude') }
                value={ longitude }
                required={ true }
                isDragEnabled={ false }
                onChange={ ( value ) => {
                  setAttributes( { longitude: parseFloat(value) } );
                } }
              />
            </PanelRow>
            <PanelRow>
              <RangeControl
                label={ __('Zoom') }
                value={ zoom }
                onChange={ ( value ) => setAttributes( { zoom: value } ) }
                min={ 0 }
                max={ 18 }
                initialPosition={12}
                allowReset={true}
              />
            </PanelRow>
          </PanelBody>
          <PanelBody
            title={ __('Marker') }
            initialOpen={false}
          >
            <PanelRow>
              <ToggleControl
                label={ __('Show marker') }
                checked={ marker }
                onChange={ () => setAttributes( { marker: !marker } ) }
              />
            </PanelRow>
            {marker &&
            <PanelRow>
              <TextControl
                label={__('Text')}
                value={markerText}
                onChange={(value) => { setAttributes({markerText: value}); }}
              />
            </PanelRow>
            }
          </PanelBody>
        </InspectorControls>
      </Fragment>
    );
  },

  save: (props) => {
    const { className, attributes } = props;
    const { blockId, latitude, longitude, zoom, marker, markerText } = attributes;

    return (
      <div className={ className} data-latitude={ latitude } data-longitude={ longitude } data-zoom={ zoom } data-marker={ marker } data-markerText={ markerText }>
        <div className={ 'map' } id={ `map-${blockId}` } />
      </div>
    );
  },
};

export default Leaflet;
